import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { LexerEvent } from "../../text/lexer/LexerEvent";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RegExpUtility } from "../../text/RegExpUtility";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";

export class RJToken extends RJExpressionNode
{
  _lexerEvent:LexerEvent;

  get match()
  { 
    return this._lexerEvent.getMatch( this.parser.source );
  }

  get tokenType()
  {
    return this._lexerEvent.type;
  }

  constructor( parser:RJParser, lexerEvent:LexerEvent )
  {
    super( parser, RJExpressionNodeType.TOKEN, lexerEvent );
    
    this._lexerEvent = lexerEvent;
  }

  writeDebugInfo( output:string[], level:number = 0 )
  {
    let ownOutput = RegExpUtility.repeat( "  ", level ) + `[${this.typeString}] = ${this._lexerEvent.match}`;
    output.push( ownOutput );
  }

  cloneNode():RJToken
  {
    let clone = new RJToken( this.parser, this._lexerEvent );
    this._copyExpressionNodeData( clone );
    return clone;
  }

  static readonly tokenType = new ElementAttribute( "token-type" );

  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    RJToken.tokenType.to( element, this.tokenType );

    return element;
  }
}